//ollow up angiography / Clinical Event

import React, {useEffect, useState} from 'react';
import style from "./REG300F1.module.scss";
import styleCom from "./REGCOM.module.scss";
import toast from "components/Toast/Toast";
import Button from "components/Button/Button";
import InputUnitText from "components/InputText/InputUnitText";
import Table from "components/Table/Table";
import DatePicker from "components/DatePicker/DatePicker";
import {calcQcaDs, dateToYMD, ymdToDate} from './REGComUtil'; //
import DynamicTable from "./REG300F6TBL";
import SelectBox from "../../components/SelectBox/SelectBox";
import RadioGroup from "../../components/Radio/RadioGroup";
import Checkbox from "../../components/Checkbox/Checkbox";


const RenderHtml = (props) => {

    let angiographyHtml=<></>;
    let clinicalEventHtml=<></>;




    const itemOptions = [
         //FU Angiography
         {mapCd: "M09001", value: "1", label: "Done"}, {mapCd: "M09001", value: "2", label: "Not Done"}
        ,{mapCd: "M09003", value: "1", label: "Ischemic related Follow up"}, {mapCd: "M09003", value: "2", label: "Scheduled Follow up"}
        ,{mapCd: "M09004", value: "1", label: "Done"}, {mapCd: "M09004", value: "2", label: "Not Done"}
        ,{mapCd: "M09005", value: "1", label: "Done"}, {mapCd: "M09005", value: "2", label: "Not Done"}
        ,{mapCd: "M09006", value: "1", label: "Done"}, {mapCd: "M09006", value: "2", label: "Not Done"}
        ,{mapCd: "M09007", value: "1", label: "Yes"}, {mapCd: "M09007", value: "2", label: "No"}
        ,{mapCd: "M09008", value: "1", label: "Type Ⅰ A"}, {mapCd: "M09008", value: "2", label: "Type Ⅰ B"}
        ,{mapCd: "M09008", value: "3", label: "Type Ⅰ C"}, {mapCd: "M09008", value: "4", label: "Type Ⅰ D"}
        ,{mapCd: "M09008", value: "5", label: "Type Ⅱ"}, {mapCd: "M09008", value: "6", label: "Type Ⅲ"}
        ,{mapCd: "M09008", value: "7", label: "Type Ⅳ"}

        //1
        ,{mapCd: "M12004", value: "1", label: "경증(mild)"}
        ,{mapCd: "M12004", value: "2", label: "중등도(moderate)"}
        ,{mapCd: "M12004", value: "3", label: "중증(severe)"}
        ,{mapCd: "M12005", value: "1", label: "예"}
        ,{mapCd: "M12005", value: "2", label: "아니오"}
        ,{mapCd: "M12006", value: "1", label: "사망하거나 생명에 대한 위협이 발생한 경우"}
        ,{mapCd: "M12006", value: "2", label: "입원할 필요가 있거나 입원 기간을 연장할 필요가 있는 경우"}
        ,{mapCd: "M12006", value: "3", label: "영구적이거나 중대한 장애 및 기능 저하를 가져온 경우"}
        ,{mapCd: "M12006", value: "4", label: "태아에게 기형 또는 이상이 발생한 경우"}
        ,{mapCd: "M12006", value: "5", label: "기타 의학적으로 중요한 상황이 발생한 경우"}
        ,{mapCd: "M12008", value: "1", label: "관련성 명백함(definitely related)"}
        ,{mapCd: "M12008", value: "2", label: "관련성이 많음(probably related)"}
        ,{mapCd: "M12008", value: "3", label: "관련성이 의심됨(possibly related)"}
        ,{mapCd: "M12008", value: "4", label: "관련성이 적음(possibly not related)"}
        ,{mapCd: "M12008", value: "5", label: "관련성이 없음(definitely not related)"}
        ,{mapCd: "M12008", value: "6", label: "불가능(unknown)"}
        ,{mapCd: "M12009", value: "1", label: "치료 없음"}
        ,{mapCd: "M12009", value: "2", label: "약물 투여"}
        ,{mapCd: "M12009", value: "3", label: "시술 및 수술"}
        ,{mapCd: "M12010", value: "1", label: "회복됨(후유증 없음)"}
        ,{mapCd: "M12010", value: "2", label: "회복됨(후유증 있음)"}
        ,{mapCd: "M12010", value: "3", label: "회복중"}
        ,{mapCd: "M12010", value: "4", label: "회복되지 않음"}
        ,{mapCd: "M12010", value: "5", label: "사망"}
        ,{mapCd: "M12010", value: "6", label: "알 수 없음"}
        //2
        ,{mapCd: "M12015", value: "1", label: "경증(mild)"}
        ,{mapCd: "M12015", value: "2", label: "중등도(moderate)"}
        ,{mapCd: "M12015", value: "3", label: "중증(severe)"}
        ,{mapCd: "M12016", value: "1", label: "예"}
        ,{mapCd: "M12016", value: "2", label: "아니오"}
        ,{mapCd: "M12017", value: "1", label: "사망하거나 생명에 대한 위협이 발생한 경우"}
        ,{mapCd: "M12017", value: "2", label: "입원할 필요가 있거나 입원 기간을 연장할 필요가 있는 경우"}
        ,{mapCd: "M12017", value: "3", label: "영구적이거나 중대한 장애 및 기능 저하를 가져온 경우"}
        ,{mapCd: "M12017", value: "4", label: "태아에게 기형 또는 이상이 발생한 경우"}
        ,{mapCd: "M12017", value: "5", label: "기타 의학적으로 중요한 상황이 발생한 경우"}
        ,{mapCd: "M12019", value: "1", label: "관련성 명백함(definitely related)"}
        ,{mapCd: "M12019", value: "2", label: "관련성이 많음(probably related)"}
        ,{mapCd: "M12019", value: "3", label: "관련성이 의심됨(possibly related)"}
        ,{mapCd: "M12019", value: "4", label: "관련성이 적음(possibly not related)"}
        ,{mapCd: "M12019", value: "5", label: "관련성이 없음(definitely not related)"}
        ,{mapCd: "M12019", value: "6", label: "불가능(unknown)"}
        ,{mapCd: "M12020", value: "1", label: "치료 없음"}
        ,{mapCd: "M12020", value: "2", label: "약물 투여"}
        ,{mapCd: "M12020", value: "3", label: "시술 및 수술"}
        ,{mapCd: "M12021", value: "1", label: "회복됨(후유증 없음)"}
        ,{mapCd: "M12021", value: "2", label: "회복됨(후유증 있음)"}
        ,{mapCd: "M12021", value: "3", label: "회복중"}
        ,{mapCd: "M12021", value: "4", label: "회복되지 않음"}
        ,{mapCd: "M12021", value: "5", label: "사망"}
        ,{mapCd: "M12021", value: "6", label: "알 수 없음"}
        //3        
        ,{mapCd: "M12026", value: "1", label: "경증(mild)"}
        ,{mapCd: "M12026", value: "2", label: "중등도(moderate)"}
        ,{mapCd: "M12026", value: "3", label: "중증(severe)"}
        ,{mapCd: "M12027", value: "1", label: "예"}
        ,{mapCd: "M12027", value: "2", label: "아니오"}
        ,{mapCd: "M12028", value: "1", label: "사망하거나 생명에 대한 위협이 발생한 경우"}
        ,{mapCd: "M12028", value: "2", label: "입원할 필요가 있거나 입원 기간을 연장할 필요가 있는 경우"}
        ,{mapCd: "M12028", value: "3", label: "영구적이거나 중대한 장애 및 기능 저하를 가져온 경우"}
        ,{mapCd: "M12028", value: "4", label: "태아에게 기형 또는 이상이 발생한 경우"}
        ,{mapCd: "M12028", value: "5", label: "기타 의학적으로 중요한 상황이 발생한 경우"}
        ,{mapCd: "M12030", value: "1", label: "관련성 명백함(definitely related)"}
        ,{mapCd: "M12030", value: "2", label: "관련성이 많음(probably related)"}
        ,{mapCd: "M12030", value: "3", label: "관련성이 의심됨(possibly related)"}
        ,{mapCd: "M12030", value: "4", label: "관련성이 적음(possibly not related)"}
        ,{mapCd: "M12030", value: "5", label: "관련성이 없음(definitely not related)"}
        ,{mapCd: "M12030", value: "6", label: "불가능(unknown)"}
        ,{mapCd: "M12031", value: "1", label: "치료 없음"}
        ,{mapCd: "M12031", value: "2", label: "약물 투여"}
        ,{mapCd: "M12031", value: "3", label: "시술 및 수술"}
        ,{mapCd: "M12032", value: "1", label: "회복됨(후유증 없음)"}
        ,{mapCd: "M12032", value: "2", label: "회복됨(후유증 있음)"}
        ,{mapCd: "M12032", value: "3", label: "회복중"}
        ,{mapCd: "M12032", value: "4", label: "회복되지 않음"}
        ,{mapCd: "M12032", value: "5", label: "사망"}
        ,{mapCd: "M12032", value: "6", label: "알 수 없음"}
        //4        12
        ,{mapCd: "M12037", value: "1", label: "경증(mild)"}
        ,{mapCd: "M12037", value: "2", label: "중등도(moderate)"}
        ,{mapCd: "M12037", value: "3", label: "중증(severe)"}
        ,{mapCd: "M12038", value: "1", label: "예"}
        ,{mapCd: "M12038", value: "2", label: "아니오"}
        ,{mapCd: "M12039", value: "1", label: "사망하거나 생명에 대한 위협이 발생한 경우"}
        ,{mapCd: "M12039", value: "2", label: "입원할 필요가 있거나 입원 기간을 연장할 필요가 있는 경우"}
        ,{mapCd: "M12039", value: "3", label: "영구적이거나 중대한 장애 및 기능 저하를 가져온 경우"}
        ,{mapCd: "M12039", value: "4", label: "태아에게 기형 또는 이상이 발생한 경우"}
        ,{mapCd: "M12039", value: "5", label: "기타 의학적으로 중요한 상황이 발생한 경우"}
        ,{mapCd: "M12041", value: "1", label: "관련성 명백함(definitely related)"}
        ,{mapCd: "M12041", value: "2", label: "관련성이 많음(probably related)"}
        ,{mapCd: "M12041", value: "3", label: "관련성이 의심됨(possibly related)"}
        ,{mapCd: "M12041", value: "4", label: "관련성이 적음(possibly not related)"}
        ,{mapCd: "M12041", value: "5", label: "관련성이 없음(definitely not related)"}
        ,{mapCd: "M12041", value: "6", label: "불가능(unknown)"}
        ,{mapCd: "M12042", value: "1", label: "치료 없음"}
        ,{mapCd: "M12042", value: "2", label: "약물 투여"}
        ,{mapCd: "M12042", value: "3", label: "시술 및 수술"}
        ,{mapCd: "M12043", value: "1", label: "회복됨(후유증 없음)"}
        ,{mapCd: "M12043", value: "2", label: "회복됨(후유증 있음)"}
        ,{mapCd: "M12043", value: "3", label: "회복중"}
        ,{mapCd: "M12043", value: "4", label: "회복되지 않음"}
        ,{mapCd: "M12043", value: "5", label: "사망"}
        ,{mapCd: "M12043", value: "6", label: "알 수 없음"}
        //5
        ,{mapCd: "M12048", value: "1", label: "경증(mild)"}
        ,{mapCd: "M12048", value: "2", label: "중등도(moderate)"}
        ,{mapCd: "M12048", value: "3", label: "중증(severe)"}
        ,{mapCd: "M12049", value: "1", label: "예"}
        ,{mapCd: "M12049", value: "2", label: "아니오"}
        ,{mapCd: "M12050", value: "1", label: "사망하거나 생명에 대한 위협이 발생한 경우"}
        ,{mapCd: "M12050", value: "2", label: "입원할 필요가 있거나 입원 기간을 연장할 필요가 있는 경우"}
        ,{mapCd: "M12050", value: "3", label: "영구적이거나 중대한 장애 및 기능 저하를 가져온 경우"}
        ,{mapCd: "M12050", value: "4", label: "태아에게 기형 또는 이상이 발생한 경우"}
        ,{mapCd: "M12050", value: "5", label: "기타 의학적으로 중요한 상황이 발생한 경우"}
        ,{mapCd: "M12052", value: "1", label: "관련성 명백함(definitely related)"}
        ,{mapCd: "M12052", value: "2", label: "관련성이 많음(probably related)"}
        ,{mapCd: "M12052", value: "3", label: "관련성이 의심됨(possibly related)"}
        ,{mapCd: "M12052", value: "4", label: "관련성이 적음(possibly not related)"}
        ,{mapCd: "M12052", value: "5", label: "관련성이 없음(definitely not related)"}
        ,{mapCd: "M12052", value: "6", label: "불가능(unknown)"}
        ,{mapCd: "M12053", value: "1", label: "치료 없음"}
        ,{mapCd: "M12053", value: "2", label: "약물 투여"}
        ,{mapCd: "M12053", value: "3", label: "시술 및 수술"}
        ,{mapCd: "M12054", value: "1", label: "회복됨(후유증 없음)"}
        ,{mapCd: "M12054", value: "2", label: "회복됨(후유증 있음)"}
        ,{mapCd: "M12054", value: "3", label: "회복중"}
        ,{mapCd: "M12054", value: "4", label: "회복되지 않음"}
        ,{mapCd: "M12054", value: "5", label: "사망"}
        ,{mapCd: "M12054", value: "6", label: "알 수 없음"}
        //6        
        ,{mapCd: "M12059", value: "1", label: "경증(mild)"}
        ,{mapCd: "M12059", value: "2", label: "중등도(moderate)"}
        ,{mapCd: "M12059", value: "3", label: "중증(severe)"}
        ,{mapCd: "M12060", value: "1", label: "예"}
        ,{mapCd: "M12060", value: "2", label: "아니오"}
        ,{mapCd: "M12061", value: "1", label: "사망하거나 생명에 대한 위협이 발생한 경우"}
        ,{mapCd: "M12061", value: "2", label: "입원할 필요가 있거나 입원 기간을 연장할 필요가 있는 경우"}
        ,{mapCd: "M12061", value: "3", label: "영구적이거나 중대한 장애 및 기능 저하를 가져온 경우"}
        ,{mapCd: "M12061", value: "4", label: "태아에게 기형 또는 이상이 발생한 경우"}
        ,{mapCd: "M12061", value: "5", label: "기타 의학적으로 중요한 상황이 발생한 경우"}
        ,{mapCd: "M12063", value: "1", label: "관련성 명백함(definitely related)"}
        ,{mapCd: "M12063", value: "2", label: "관련성이 많음(probably related)"}
        ,{mapCd: "M12063", value: "3", label: "관련성이 의심됨(possibly related)"}
        ,{mapCd: "M12063", value: "4", label: "관련성이 적음(possibly not related)"}
        ,{mapCd: "M12063", value: "5", label: "관련성이 없음(definitely not related)"}
        ,{mapCd: "M12063", value: "6", label: "불가능(unknown)"}
        ,{mapCd: "M12064", value: "1", label: "치료 없음"}
        ,{mapCd: "M12064", value: "2", label: "약물 투여"}
        ,{mapCd: "M12064", value: "3", label: "시술 및 수술"}
        ,{mapCd: "M12065", value: "1", label: "회복됨(후유증 없음)"}
        ,{mapCd: "M12065", value: "2", label: "회복됨(후유증 있음)"}
        ,{mapCd: "M12065", value: "3", label: "회복중"}
        ,{mapCd: "M12065", value: "4", label: "회복되지 않음"}
        ,{mapCd: "M12065", value: "5", label: "사망"}
        ,{mapCd: "M12065", value: "6", label: "알 수 없음"}

    ];

    const activeFlagObj = props.activeFlagObj;

    function getOptionList(cdValue) {
        return itemOptions.filter(option => option.mapCd === cdValue);
    }

    const activeEvent = (mapCd, value="") =>{
        /* activeEvent :
         * - 이벤트 발생시 코드와 값을 기준으로 컴포넌트 활성화/비활성화를 제어하는 상태값 변경
         * - 데이터가 존재하는 activeFlag 필드 값을 변경하여 제어( readOlny 같은 옵션에서 값을 참조하는방식)
         */
        const matchedObj = activeFlagObj.filter(item =>
            item.mapCd === mapCd && item.chkFlag==='matched' && item.chkVal === value
        );
        const notMatchedObj = activeFlagObj.filter(item =>
            item.mapCd === mapCd && item.chkFlag==='notMatched'
        );


        if(matchedObj.length > 0){
            matchedObj.forEach(item => {
                if(matchedObj.length > 0 && item.chkVal === value){
                    props.setDtlValue(item.tarId, item.tarFlag, 'activeFlag');
                    props.setDtlValue(item.tarId, item.tarVal, 'itmRslt');
                }
            });
        }else if(notMatchedObj.length > 0){
            notMatchedObj.forEach(item => {
                props.setDtlValue(item.tarId, item.tarFlag, 'activeFlag');
                props.setDtlValue(item.tarId, item.tarVal, 'itmRslt');
            });
        }

    }




    /* ****************************************************************************** Event */

    /* [가변형]의료기기 이상반응 이벤트 ***************************************************************
    * *************************************************************************************** */

    const disableMapCd = "M12000"; // 이상반응 화면 해당없음 제어를 위한 MAP_CD

    const startId = "12001"; // 원하는 시작값 설정 가능
    const tableCount = 6; // 테이블 개수
    const itemsPerTable = 11; // 각 테이블당 아이템 개수
    const [tableList, setTableList] = useState([{ index: 1 }]);

    const repeatingTableObj = generateTableList('M'+ startId);  //다이나믹 테이블 ID

    //폼 로드
    useEffect(() => {
        loadRepeatingTable();
    }, []);

    // 이상반응 데이터 로드시 테이터가 존재하는 테이블 갯수 표시
    const loadRepeatingTable = () => {
        setTableList(prevTables => {
            let currentTableCount = prevTables.length;
            const data = repeatingTableObj;
            let newTables = [...prevTables];

            for (let i = 2; i <= 6; i++) {
                const hasData = data.some(item => {
                    const value = props.getDtlValue(item.mapCd);
                    return value !== "" && value !== null && item.index === i;
                });

                if (!hasData) {
                    break;
                }
                //console.log("prevTables : " + currentTableCount + " / " + i);
                if (!newTables.some(table => table.index === i)) {
                    newTables.push({ index: i });
                    currentTableCount++;
                }
            }
            return newTables;
        });

        // 테이블 개수가 부족하고 데이터가 있는 경우에만 `addTable()` 실행
        setTimeout(() => {
            const latestCount = tableList.length;
            const maxGroupIndex = Math.max(...tableList.map(t => t.index), 1); // 현재 추가된 최대 그룹 번호
            //console.log("최신 테이블 개수:", latestCount);
            //console.log("데이터가 있는 마지막 그룹:", maxGroupIndex);

            if (latestCount < maxGroupIndex) {
                addTable();
            }
        }, 0);
    };


    function generateTableList(startMapCd) {
        const result = [];
        const baseChar = startMapCd.charAt(0); // 'M'
        let num = parseInt(startMapCd.slice(1), 10); // '01001' → 1001

        for (let i = 0; i < 66; i++) {
            const index = Math.floor(i / itemsPerTable) + 1; // 그룹화 → 1~6 itemsPerTable은 그룹에 포함될 ID갯수
            const mapCd = `${baseChar}${String(num).padStart(5, '0')}`; // 'M' + '01001' 형태 유지
            result.push({ index, mapCd });
            num++; // 숫자 증가
        }
        return result;
    }

    // 테이블 목록 생성 (직접 id, value 저장)
    const [tables, setTables] = useState(
        Array.from({ length: tableCount * itemsPerTable }, (_, i) => ({
            tableIndex: Math.floor(i / itemsPerTable) + 1, // 테이블 번호
            id: `M${String(startId + i).padStart(5, "0")}`, // ID 자리수 유지
            value: props.getDtlValue(`M${String(startId + i).padStart(5, "0")}`) || "" // null 처리
        }))
    );

    //참조 코드표 테이블 생성 ▲
    //펑션 html 호출 및 제어 +/-버튼
    // - 테이블 갯수와 데이터 확인해서 기본 상태에서는 테이블 1개만 보이도록 하고
    // - 데이터 존재한 만큼 추가표시 후 버튼 이벤트 수행
    const addTable = () => {
        setTableList(prevTables => {
            if (prevTables.length >= 6) {
                toast({ type: 'info', message: "최대 6개의 테이블만 추가할 수 있습니다." });
                return prevTables;
            }
            const newIndex = prevTables.length > 0 ? Math.max(...prevTables.map(t => t.index)) + 1 : 1;
            return [...prevTables, { index: newIndex }];
        });
    };

    //테이블 삭제
    const removeTable = (index) => {
        setTableList(prevTables => {
            if (prevTables.length <= 1) {
                toast({ type: 'info', message: "최소 1개의 테이블은 유지되어야 합니다." });
                return prevTables;
            }
            clearGroupData(index);
            return prevTables.filter(table => table.index !== index);
        });
    };

    //그룹에 속해있는 데이터를 초기화하는 함수
    const clearGroupData = (groupIndex) => {
        const groupDataIds = repeatingTableObj
            .filter(item => item.index === groupIndex) // 해당 그룹에 속한 데이터 필터링
            .map(item => item.mapCd); // id만 가져오기
        groupDataIds.forEach(mapCd => (props.setDtlValue(mapCd, ""))

        ); // 해당 그룹의 데이터 초기화
    };

    /* *************************************************************** [가변형]의료기기 이상반응 */

    /* User Event ****************************************************************************** */

    const compValue = (mpaCd) => {
        return props.getDtlValue(mpaCd);
    };

    const compChange = (mapCd, value) => {
        props.setDtlValue(mapCd, value);
        activeEvent(mapCd, value);

        /* FU Angiography - QCA, 잔여협착(DS) 계산 ******************************* */
        if(mapCd==='M09009'){
            props.setDtlValue('M09011',calcQcaDs(value, props.getDtlValue('M09010')) );
        }else if(mapCd==='M09010') {
            props.setDtlValue('M09011',calcQcaDs(props.getDtlValue('M09009'), value) );
        }

        /* **************************************************************
        *  - Clinical Event 해당없음(ND) 체크시 테이블을 최소로 초기화
        *    (데이터는 클릭이벤트에서 제거됨)
        *  - 화면에 보이지 않아도 체크 해제를 대비하여 예외처리
        * */
        if (mapCd === disableMapCd && props.getDtlValue(disableMapCd) === '1'){
            setTableList(prevTables => {
                return prevTables.filter(table => table.index === 1);
            });
        }

    };




    angiographyHtml =
        <>
            <div className={styleCom.title_wrap}>
                <h3>Follow up angiography</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={10} colSize={['25%', '75%']} rowSize={'56px'}>
                    <div>Angiographic Follow up</div>
                    <div>
                        <RadioGroup options={getOptionList('M09001')}
                                    selectedValue={props.getDtlValue('M09001')}
                                    onChange={(val) => compChange('M09001', val)}/>
                    </div>
                    <div>Angiographic Follow up date</div>
                    <div>
                        <DatePicker selDate={ymdToDate(props.getDtlValue('M09002'))} dateFormat={'yyyy-MM-dd'}
                                    onChange={(date) => props.setDtlValue('M09002', dateToYMD(date))}
                                    isDisabled={props.getDtlValue('M09002', 'activeFlag')}/>
                    </div>
                    <div>Follow up type</div>
                    <div>
                        <RadioGroup options={getOptionList('M09003')}
                                    selectedValue={props.getDtlValue('M09003')}
                                    onChange={(val) => props.setDtlValue('M09003', val)}
                                    disabled={props.getDtlValue('M09003', 'activeFlag')}/>
                    </div>
                    <div>IVUS evaluation</div>
                    <div>
                        <RadioGroup options={getOptionList('M09004')}
                                    selectedValue={props.getDtlValue('M09004')}
                                    onChange={(val) => props.setDtlValue('M09004', val)}
                                    disabled={props.getDtlValue('M09004', 'activeFlag')}/>
                    </div>
                    <div>OCT evaluation</div>
                    <div>
                        <RadioGroup options={getOptionList('M09005')}
                                    selectedValue={props.getDtlValue('M09005')}
                                    onChange={(val) => props.setDtlValue('M09005', val)}
                                    disabled={props.getDtlValue('M09005', 'activeFlag')}/>
                    </div>
                    <div>FFR or iFR or RFR</div>
                    <div>
                        <RadioGroup options={getOptionList('M09006')}
                                    selectedValue={props.getDtlValue('M09006')}
                                    onChange={(val) => props.setDtlValue('M09006', val)}
                                    disabled={props.getDtlValue('M09006', 'activeFlag')}/>
                    </div>
                    <div>In-stent restenosis</div>
                    <div>
                        <table className={style.customLine} style={{height: "56px"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <RadioGroup options={getOptionList('M09007')}
                                                selectedValue={props.getDtlValue('M09007')}
                                                onChange={(val) => compChange('M09007', val)}
                                                disabled={props.getDtlValue('M09007', 'activeFlag')}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p style={{marginBottom: "8px"}}> If yes, Type of in-stent restenosis </p>
                                    <SelectBox options={getOptionList('M09008')}
                                               valueKey="value" labelKey="label"
                                               value={props.getDtlValue('M09008')}
                                               onChange={(val) => props.setDtlValue('M09008', val)}
                                               width={'25%'} isDisabled={props.getDtlValue('M09008', 'activeFlag')}/>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>최소내강직경(MLD,mm)</div>
                    <div>
                        <InputUnitText type={"text"} value={props.getDtlValue('M09009')} unit={"mm"}
                                       onChange={(value) => compChange("M09009", value)}
                                       readOnly={props.getDtlValue("M09009", 'activeFlag')}/>
                    </div>
                    <div>참조혈관의 직경(RVD,mm)</div>
                    <div>
                        <InputUnitText type={"text"} value={props.getDtlValue('M09010')} unit={"mm"}
                                       onChange={(value) => compChange("M09010", value)}
                                       readOnly={props.getDtlValue("M09010", 'activeFlag')}/>
                    </div>
                    <div>
                        <span className={style.cellText2}>
                            <div className={style.cellText1}>협착률, QCA(%)</div>
                            (1-[MLD/RVD]) x 100</span>
                    </div>

                    <div>
                        <InputUnitText type={"text"} value={props.getDtlValue('M09011')} unit={"%"}
                                       onChange={(value) => props.setDtlValue("M09011", value)}
                                       readOnly={props.getDtlValue("M09011", 'activeFlag')}/>
                    </div>
                </Table>

            </div>


        </>
    ;
    clinicalEventHtml =
        <>
            <div style={{display: "flex", gap: "20px"}}>
                <h3>의료기기 이상반응</h3>
                <Checkbox label={"해당없음 (NA)"}
                          onChange={(e) => compChange(disableMapCd, e.target.checked ? '1' : '0')}
                          checked={props.getDtlValue(disableMapCd) === '1'}/>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <div>
                    {tableList.map((table) => (
                        <DynamicTable key={table.index} index={table.index}
                                      getDtlValue={props.getDtlValue} setDtlValue={props.setDtlValue}
                                      getOptionList={getOptionList} startCd={"M" + startId}/>
                    ))}
                </div>
                <div style={{display: "flex", gap: "8px", height: "100%", justifyContent: "center"}}>
                    <Button variant="Secondary" addStyle={{width: "124px", height: "40px"}}
                            onClick={() => addTable()}>추가</Button>
                    <Button variant="Secondary" addStyle={{width: "124px", height: "40px"}}
                            onClick={() => removeTable(tableList.length > 0 ? tableList[tableList.length - 1].index : null)}>
                        삭제</Button>
                </div>
            </div>

        </>
    ;
    const clinicalEventHtmlDisable =
        <div style={{display: "flex", gap: "20px"}}>
            <h3>[Clinical Event] 사용시 체크를 해제하여 주십시오.</h3>
            <Checkbox label={"해당없음 (NA)"}
                      onChange={(e) => compChange(disableMapCd, e.target.checked ? '1' : '0')}
                      checked={props.getDtlValue( disableMapCd ) === '1'}/>
        </div>
    ;

    let renderHtml =
        <></>
    ;

    if (props.contentId === "T11") {
        renderHtml = angiographyHtml;
    }else if (props.contentId === "T13") {
        if(props.getDtlValue(disableMapCd) === '1'){
            renderHtml = clinicalEventHtmlDisable;
        }else{
            renderHtml = clinicalEventHtml;
        }

    } else {
        renderHtml = <>준비중 입니다.</>;
    }
    return (
        <>
            {renderHtml}
        </>
    );

};

export default RenderHtml;

